import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue/es'
// import '@/core/lazy_lib/components_use'
import 'ant-design-vue/dist/antd.less';
import '@/styles/index.less';
import VueQriously from 'vue-qriously'

Vue.use(VueQriously)
Vue.config.productionTip = false
Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
